/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assetLinkingFormModalClose: "asset-linking-form-modal-close",
  assetLinkingFormModalSave: "asset-linking-form-modal-save",
} as const;
